import { Box, Button, Stack, Tab, Tabs, Typography } from '@mui/material'
import { AgGridReact } from '@ag-grid-community/react'
import { useLocation, useNavigate } from "react-router-dom";
import { PIDashboardColumns } from "./PIDashboardColumns";
import KeyboardReturnOutlinedIcon from '@mui/icons-material/KeyboardReturnOutlined';
import { SyntheticEvent, useState } from "react";
import RemoveSubApplicantModal from "./components/RemoveSubApplicantModal";
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { useGetDUCInfoQuery, useGetSubApplicantsQuery } from "../../api/ducApiSlice";
import { useUserInfoQuery } from "../../api/userApiSlice";

const PIDashboard = () => {
    const { data: userData } = useUserInfoQuery({});
    const { data } = useGetSubApplicantsQuery({ username: userData?.username });
    const { data: DUCData } = useGetDUCInfoQuery({ email: userData['email'] })
    const location = useLocation()
    const navigate = useNavigate()
    const [open,setOpen] = useState(false)
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [id, setId] = useState("")
    const [ tab, setTab ] = useState(location.state?.type || "GENERAL");


    const handleClickDelete = (event: any) => {
        if(event.colDef.field === "remove" && event.data.ducStatus === "Approved" && event.data.isRemoved !== true){
            setOpen(true)
            setName(event.data.name)
            setEmail(event.data.email)
            setId(event.data.id)
        }
    }

    const handelCLickAdd = () => {
        localStorage.setItem('AddSub', "true")
        localStorage.setItem('edit', "true")
        localStorage.setItem('isGroup', "true")
        localStorage.setItem("formType", tab)
        navigate("/duc/request")
    }

    const changeTab = (event: SyntheticEvent, newValue: string) => {
        setTab(newValue);
    }

    const checkDisabled = () => {
        if(data?.[tab]?.length === 0){
            return true
        }
        const ducDataTab = DUCData?.[tab]
        const isDuc1NotApproved = ducDataTab?.[0]?.status !== "Approved";
        const does2DucExist = (ducDataTab?.length === 2);
        const isDuc2InProgressOrSubmitted = ducDataTab?.[1]?.status === "Submitted" || ducDataTab?.[1]?.status === "InProgress"
        return isDuc1NotApproved || (does2DucExist && isDuc2InProgressOrSubmitted);
    }

    return (
        <Stack height="100%" gap={4}>
            <Typography fontSize="40px" fontWeight={600} textAlign="center">Investigator Dashboard </Typography>
            <Stack flexDirection="row" justifyContent="space-between">
                <Button
                    startIcon={<KeyboardReturnOutlinedIcon/>}
                    variant="tertiary"
                    onClick={() => navigate("/duc")}
                >Back to DUC dashboard</Button>

                <Button
                    variant="primary"
                    disabled={checkDisabled()}
                    startIcon={<AddBoxOutlinedIcon/>}
                    onClick={handelCLickAdd}>
                    Add new Sub-applicant
                </Button>

            </Stack>
            <Box width="100%" height="100%" className="ag-theme-material ag-theme-common ag-theme-acmecorp">
                <Typography fontSize="18px" fontWeight="600">Sub-applicants in your group</Typography>
                <Tabs value={tab} onChange={changeTab}>
                    <Tab value="GENERAL" label={`General (${data?.GENERAL?.length})`} />
                    <Tab value="AIAN" label={`AIAN (${data?.AIAN?.length})`} />
                </Tabs>
                <AgGridReact rowData={data?.[tab]} columnDefs={PIDashboardColumns}
                    rowSelection={{ mode: "multiRow", headerCheckbox: true, checkboxes: true }}
                    onCellClicked= {(event: any) => handleClickDelete(event)}/>
            </Box>
            <RemoveSubApplicantModal open={open} setOpen={setOpen} name={name} email={email} id={id}/>
        </Stack >
    )
}

export default PIDashboard